// "use client";

// import { useEffect, useMemo, useRef, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faBook,
//   faPlus,
//   faTrash,
//   faSave,
//   faClock,
//   faRupeeSign,
//   faUsers,
//   faSpinner,
//   faCalendarAlt,
// } from "@fortawesome/free-solid-svg-icons";
// import { baseUrl } from "../../config/baseUrl";

// const createEmptySlot = () => ({
//   libraryPrice: "",
//   numberOfSeats: "",
//   remainingSeats: "",
//   tenure: "",
//   fromTimeHours: "",
//   fromTimestamp: "AM",
//   toTimeHours: "",
//   toTimestamp: "AM",
// });

// const SLOT_SEGMENTS = [
//   {
//     code: "A",
//     fromTimeHours: "6:00",
//     fromTimestamp: "AM",
//     toTimeHours: "11:00",
//     toTimestamp: "AM",
//   },
//   {
//     code: "B",
//     fromTimeHours: "11:00",
//     fromTimestamp: "AM",
//     toTimeHours: "4:00",
//     toTimestamp: "PM",
//   },
//   {
//     code: "C",
//     fromTimeHours: "4:00",
//     fromTimestamp: "PM",
//     toTimeHours: "10:00",
//     toTimestamp: "PM",
//   },
//   {
//     code: "D",
//     fromTimeHours: "10:00",
//     fromTimestamp: "PM",
//     toTimeHours: "6:00",
//     toTimestamp: "AM",
//   },
// ];

// const COMBINATION_GUIDE_ROWS = [
//   {
//     slot: "Slot 1",
//     fromTimeHours: "6:00",
//     fromTimestamp: "AM",
//     toTimeHours: "11:00",
//     toTimestamp: "AM",
//     fees: "400",
//   },
//   {
//     slot: "Slot 2",
//     fromTimeHours: "11:00",
//     fromTimestamp: "AM",
//     toTimeHours: "4:00",
//     toTimestamp: "PM",
//     fees: "400",
//   },
//   {
//     slot: "Slot 3",
//     fromTimeHours: "4:00",
//     fromTimestamp: "PM",
//     toTimeHours: "10:00",
//     toTimestamp: "PM",
//     fees: "400",
//   },
//   {
//     slot: "Slot 4",
//     fromTimeHours: "10:00",
//     fromTimestamp: "PM",
//     toTimeHours: "6:00",
//     toTimestamp: "AM",
//     fees: "400",
//   },
//   {
//     slot: "Slot 5",
//     fromTimeHours: "6:00",
//     fromTimestamp: "AM",
//     toTimeHours: "4:00",
//     toTimestamp: "PM",
//     fees: "700",
//   },
//   {
//     slot: "Slot 6",
//     fromTimeHours: "6:00",
//     fromTimestamp: "AM",
//     toTimeHours: "10:00",
//     toTimestamp: "PM",
//     fees: "1000",
//   },
//   {
//     slot: "Slot 7",
//     fromTimeHours: "10:00",
//     fromTimestamp: "PM",
//     toTimeHours: "10:00",
//     toTimestamp: "PM",
//     fees: "1500 (full day)",
//   },
// ];

// const parseTimeToMinutes = (timeHours, timestamp) => {
//   if (!timeHours || !timestamp) {
//     return null;
//   }

//   const [hourText, minuteText] = timeHours.split(":");
//   const hour = Number(hourText);
//   const minute = Number(minuteText || "0");

//   if (Number.isNaN(hour) || Number.isNaN(minute)) {
//     return null;
//   }

//   let normalizedHour = hour % 12;

//   if (timestamp === "PM") {
//     normalizedHour += 12;
//   }

//   return normalizedHour * 60 + minute;
// };

// const formatTimeForDisplay = (timeHours, timestamp) => {
//   if (!timeHours || !timestamp) {
//     return "-";
//   }

//   const [hourText] = timeHours.split(":");
//   return `${Number(hourText)} ${timestamp}`;
// };

// const resolveSlotCombination = (slot) => {
//   const startMinutes = parseTimeToMinutes(slot.fromTimeHours, slot.fromTimestamp);
//   const endMinutes = parseTimeToMinutes(slot.toTimeHours, slot.toTimestamp);

//   if (startMinutes === null || endMinutes === null) {
//     return "";
//   }

//   let normalizedStart = startMinutes;
//   let normalizedEnd = endMinutes;

//   if (normalizedEnd <= normalizedStart) {
//     normalizedEnd += 24 * 60;
//   }

//   if (normalizedStart < 360) {
//     normalizedStart += 24 * 60;
//     normalizedEnd += 24 * 60;
//   }

//   if (normalizedEnd - normalizedStart === 24 * 60) {
//     return "A+B+C+D";
//   }

//   const segments = [];

//   [0, 24 * 60, 2 * 24 * 60].forEach((offset) => {
//     SLOT_SEGMENTS.forEach((segment) => {
//       const segmentStart = parseTimeToMinutes(
//         segment.fromTimeHours,
//         segment.fromTimestamp
//       );
//       let segmentEnd = parseTimeToMinutes(
//         segment.toTimeHours,
//         segment.toTimestamp
//       );

//       if (segmentStart === null || segmentEnd === null) {
//         return;
//       }

//       if (segmentEnd <= segmentStart) {
//         segmentEnd += 24 * 60;
//       }

//       segments.push({
//         code: segment.code,
//         start: segmentStart + offset,
//         end: segmentEnd + offset,
//       });
//     });
//   });

//   const segmentByStart = segments.reduce((acc, segment) => {
//     acc[segment.start] = segment;
//     return acc;
//   }, {});

//   const selectedSegments = [];
//   let cursor = normalizedStart;

//   while (cursor < normalizedEnd) {
//     const currentSegment = segmentByStart[cursor];

//     if (!currentSegment || currentSegment.end > normalizedEnd) {
//       return "";
//     }

//     selectedSegments.push(currentSegment.code);
//     cursor = currentSegment.end;
//   }

//   return cursor === normalizedEnd ? selectedSegments.join("+") : "";
// };

// export default function LibrarySlots() {
//   const navigate = useNavigate();
//   const addedSlotIndexRef = useRef(null);

//   const [fetchLoading, setFetchLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [tenureList, setTenureList] = useState([]);
//   const [slots, setSlots] = useState([createEmptySlot()]);
//   const [baselineSlots, setBaselineSlots] = useState("[]");

//   const [libraryMeta, setLibraryMeta] = useState({
//     libraryName: "",
//     city: "",
//     area: "",
//   });
//   const [libraryPayload, setLibraryPayload] = useState({
//     libraryName: "",
//     email: "",
//     city: "",
//     area: "",
//     address: "",
//     pinCode: "",
//     contactPersonName: "",
//     contactPersonNumber: "",
//     aboutLibrary: "",
//     paymentAcceptance: "Both",
//     ownerName: "",
//     ownerPhoneNumber: "",
//     bankName: "",
//     bankAccountNumber: "",
//     bankIfscCode: "",
//     emptyField1: "",
//     emptyField2: "",
//     adminCommission: {
//       type: "",
//       value: null,
//     },
//   });

//   const timeOptions = useMemo(() => {
//     const options = [];
//     for (let i = 1; i <= 12; i++) {
//       options.push(`${i}:00`);
//       options.push(`${i}:30`);
//     }
//     return options;
//   }, []);

//   const hasUnsavedChanges = useMemo(
//     () => JSON.stringify(slots) !== baselineSlots,
//     [slots, baselineSlots]
//   );

//   const combinationGuideRows = useMemo(
//     () =>
//       COMBINATION_GUIDE_ROWS.map((row) => ({
//         ...row,
//         combination: resolveSlotCombination(row),
//       })),
//     []
//   );

//   const slotCount = slots.length;
//   const totalSeats = slots.reduce(
//     (sum, slot) => sum + (Number(slot.numberOfSeats) || 0),
//     0
//   );
//   const totalRemainingSeats = slots.reduce(
//     (sum, slot) => sum + (Number(slot.remainingSeats) || 0),
//     0
//   );
//   const occupancyRate =
//     totalSeats > 0
//       ? Math.round(((totalSeats - totalRemainingSeats) / totalSeats) * 100)
//       : 0;

//   useEffect(() => {
//     const initializePage = async () => {
//       try {
//         setFetchLoading(true);
//         await Promise.all([fetchLibraryData(), fetchTenureData()]);
//       } catch (error) {
//         toast.error(error.message || "Failed to load library slots");
//       } finally {
//         setFetchLoading(false);
//       }
//     };

//     initializePage();
//   }, []);

//   const fetchTenureData = async () => {
//     const response = await fetch(`${baseUrl}/library-tenure?status=active`, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     });

//     const data = await response.json();

//     if (data.status && data.data) {
//       setTenureList(data.data);
//       return;
//     }

//     throw new Error(data.message || "Failed to fetch tenure data");
//   };

//   const fetchLibraryData = async () => {
//     const response = await fetch(`${baseUrl}/owner/library/details`, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     });

//     const data = await response.json();

//     if (!(data.status && data.data)) {
//       if (response.status === 401) {
//         navigate("/login");
//       }
//       throw new Error(data.message || "Failed to fetch library data");
//     }

//     const library = data.data;

//     setLibraryMeta({
//       libraryName: library.libraryName || "My Library",
//       city: library.city || "",
//       area: library.area || "",
//     });

//     setLibraryPayload({
//       libraryName: library.libraryName || "",
//       email: library.email || "",
//       city: library.city || "",
//       area: library.area || "",
//       address: library.address || "",
//       pinCode: library.pinCode || "",
//       contactPersonName: library.contactPersonName || "",
//       contactPersonNumber: library.contactPersonNumber || "",
//       aboutLibrary: library.aboutLibrary || "",
//       paymentAcceptance: library.paymentAcceptance || "Both",
//       ownerName: library.ownerName || "",
//       ownerPhoneNumber: library.ownerPhoneNumber || "",
//       bankName: library.bankName || "",
//       bankAccountNumber: library.bankAccountNumber || "",
//       bankIfscCode: library.bankIfscCode || "",
//       emptyField1: library.emptyField1 || "",
//       emptyField2: library.emptyField2 || "",
//       adminCommission: {
//         type: library?.adminCommission?.type || "",
//         value:
//           library?.adminCommission?.value === undefined
//             ? null
//             : library?.adminCommission?.value,
//       },
//     });

//     const formattedSlots =
//       library.slots && library.slots.length > 0
//         ? library.slots.map((slot) => ({
//           libraryPrice: slot.libraryPrice?.toString() || "",
//           numberOfSeats: slot.numberOfSeats?.toString() || "",
//           remainingSeats: slot.remainingSeats?.toString() || "",
//           tenure: slot.tenure || "",
//           fromTimeHours: slot.fromTimeHours || "",
//           fromTimestamp: slot.fromTimestamp || "AM",
//           toTimeHours: slot.toTimeHours || "",
//           toTimestamp: slot.toTimestamp || "AM",
//           slotId: slot.slotId,
//           _id: slot._id,
//         }))
//         : [createEmptySlot()];

//     setSlots(formattedSlots);
//     setBaselineSlots(JSON.stringify(formattedSlots));
//   };

//   const handleSlotChange = (index, field, value) => {
//     setSlots((prev) =>
//       prev.map((slot, slotIndex) =>
//         slotIndex === index ? { ...slot, [field]: value } : slot
//       )
//     );
//   };

//   const addSlot = () => {
//     setSlots((prev) => {
//       const nextSlots = [...prev, createEmptySlot()];
//       addedSlotIndexRef.current = nextSlots.length - 1;
//       return nextSlots;
//     });
//   };

//   useEffect(() => {
//     if (addedSlotIndexRef.current === null) {
//       return;
//     }

//     const targetCard = document.getElementById(
//       `library-slot-card-${addedSlotIndexRef.current}`
//     );

//     if (targetCard) {
//       window.requestAnimationFrame(() => {
//         targetCard.scrollIntoView({ behavior: "smooth", block: "start" });
//       });
//     }

//     addedSlotIndexRef.current = null;
//   }, [slots]);

//   const removeSlot = (index) => {
//     if (slots.length === 1) {
//       toast.info("At least one slot is required");
//       return;
//     }

//     setSlots((prev) => prev.filter((_, slotIndex) => slotIndex !== index));
//   };

//   const validateSlots = () => {
//     for (let i = 0; i < slots.length; i++) {
//       const slot = slots[i];
//       const slotLabel = slot.slotId || `Slot ${i + 1}`;

//       if (!slot.libraryPrice || Number(slot.libraryPrice) <= 0) {
//         toast.error(`Enter a valid price for ${slotLabel}`);
//         return false;
//       }

//       if (!slot.numberOfSeats || Number(slot.numberOfSeats) <= 0) {
//         toast.error(`Enter valid seats for ${slotLabel}`);
//         return false;
//       }

//       if (!slot.tenure) {
//         toast.error(`Select tenure for ${slotLabel}`);
//         return false;
//       }

//       if (!slot.fromTimeHours || !slot.toTimeHours) {
//         toast.error(`Select both From and To time for ${slotLabel}`);
//         return false;
//       }
//     }

//     return true;
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();

//     if (!validateSlots()) {
//       return;
//     }

//     try {
//       setSaving(true);

//       const submitFormData = new FormData();

//       Object.keys(libraryPayload).forEach((key) => {
//         if (key === "adminCommission") {
//           submitFormData.append(
//             "adminCommission",
//             JSON.stringify(libraryPayload[key])
//           );
//         } else {
//           submitFormData.append(key, libraryPayload[key] || "");
//         }
//       });

//       const sanitizedSlots = slots.map((slot) => ({
//         libraryPrice: slot.libraryPrice,
//         numberOfSeats: slot.numberOfSeats,
//         remainingSeats: slot.remainingSeats,
//         tenure: slot.tenure,
//         fromTimeHours: slot.fromTimeHours,
//         fromTimestamp: slot.fromTimestamp || "AM",
//         toTimeHours: slot.toTimeHours,
//         toTimestamp: slot.toTimestamp || "AM",
//         slotId: slot.slotId,
//         _id: slot._id,
//       }));

//       submitFormData.append("slots", JSON.stringify(sanitizedSlots));

//       const response = await fetch(`${baseUrl}/owner/library/update`, {
//         method: "PUT",
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//         body: submitFormData,
//       });

//       const data = await response.json();

//       if (data.status) {
//         toast.success("Library slots updated successfully");
//         await fetchLibraryData();
//         return;
//       }

//       toast.error(data.message || "Failed to update library slots");
//     } catch (error) {
//       toast.error(error.message || "Failed to update library slots");
//     } finally {
//       setSaving(false);
//     }
//   };

//   if (fetchLoading) {
//     return (
//       <section className="main-sec">
//         <div className="container-fluid">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="cards">
//                 <div className="text-center py-5">
//                   <FontAwesomeIcon
//                     icon={faSpinner}
//                     spin
//                     size="3x"
//                     className="text-primary mb-3"
//                   />
//                   <h4>Loading Library Slots...</h4>
//                   <p className="text-muted">
//                     Please wait while we prepare your slot configuration.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <section className="main-sec">
//       <div className="container-fluid">
//         <div className="row align-items-start">
//           <div className="col-lg-8">
//             <div className="dashboard-title">
//               <h4 className="dash-head">
//                 <FontAwesomeIcon icon={faBook} className="me-2" />
//                 Library Slots
//               </h4>
//             </div>
//             <div className="custom-bredcump">
//               <nav aria-label="breadcrumb">
//                 <ol className="breadcrumb">
//                   <li className="breadcrumb-item">
//                     <Link to="/">Dashboard</Link>
//                   </li>
//                   <li className="breadcrumb-item">
//                     <Link to="/library">My Library</Link>
//                   </li>
//                   <li className="breadcrumb-item active" aria-current="page">
//                     Library Slots
//                   </li>
//                 </ol>
//               </nav>
//             </div>
//           </div>
//           <div className="col-lg-4 d-flex justify-content-lg-end">
//             <Link to="/library" className="btn btn-outline-primary mt-2 mt-lg-0">
//               Back to My Library
//             </Link>
//           </div>
//         </div>

//         <div className="row mb-3">
//           <div className="col-12">
//             <div className="slot-module-intro">
//               <div>
//                 <h6 className="mb-1">{libraryMeta.libraryName}</h6>
//                 <p className="mb-0 text-muted">
//                   {libraryMeta.area && libraryMeta.city
//                     ? `${libraryMeta.area}, ${libraryMeta.city}`
//                     : "Manage slot timings, capacity, and tenure from one place."}
//                 </p>
//               </div>
//               <button
//                 type="button"
//                 className="btn btn-primary btn-sm"
//                 onClick={addSlot}
//               >
//                 <FontAwesomeIcon icon={faPlus} className="me-2" />
//                 Add Slot
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="row mb-3">
//           <div className="col-12">
//             <div className="slot-combo-guide">
//               <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
//                 <h6 className="mb-0">Slot Combination Guide</h6>
//                 <small className="text-muted">
//                   Combination is auto-detected from From/To time.
//                 </small>
//               </div>
//               <div className="table-responsive">
//                 <table className="table table-sm table-bordered mb-0">
//                   <thead>
//                     <tr>
//                       <th>Slot</th>
//                       <th>From</th>
//                       <th>To</th>
//                       <th>Fees</th>
//                       <th>Combination</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {combinationGuideRows.map((row) => (
//                       <tr key={row.slot}>
//                         <td>{row.slot}</td>
//                         <td>
//                           {formatTimeForDisplay(row.fromTimeHours, row.fromTimestamp)}
//                         </td>
//                         <td>{formatTimeForDisplay(row.toTimeHours, row.toTimestamp)}</td>
//                         <td>{row.fees}</td>
//                         <td>{row.combination || "Custom"}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* <div className="row mb-4">
//           <div className="col-md-3 col-6 mb-3">
//             <div className="slot-summary-card">
//               <p>Total Slots</p>
//               <h5>{slotCount}</h5>
//             </div>
//           </div>
//           <div className="col-md-3 col-6 mb-3">
//             <div className="slot-summary-card">
//               <p>Total Seats</p>
//               <h5>{totalSeats}</h5>
//             </div>
//           </div>
//           <div className="col-md-3 col-6 mb-3">
//             <div className="slot-summary-card">
//               <p>Remaining Seats</p>
//               <h5>{totalRemainingSeats}</h5>
//             </div>
//           </div>
//           <div className="col-md-3 col-6 mb-3">
//             <div className="slot-summary-card">
//               <p>Occupancy</p>
//               <h5>{occupancyRate}%</h5>
//             </div>
//           </div>
//         </div> */}

//         <form onSubmit={handleSubmit}>
//           <div className="row mb-3">
//             {slots.map((slot, index) => {
//               const slotTitle = slot.slotId || `Slot ${index + 1}`;
//               const slotCombination = resolveSlotCombination(slot);
//               const isTenureListed = tenureList.some(
//                 (tenure) => tenure._id === slot.tenure
//               );

//               return (
//                 <div
//                   id={`library-slot-card-${index}`}
//                   key={`${slot._id || "new"}-${index}`}
//                   className="col-12 mb-3"
//                 >
//                   <div className="card slot-card">
//                     <div className="card-header d-flex justify-content-between align-items-center">
//                       <div className="d-flex align-items-center gap-2">
//                         <h6 className="mb-0">{slotTitle}</h6>
//                         <span
//                           className={`slot-combo-badge ${slotCombination ? "" : "custom"}`}
//                         >
//                           {slotCombination || "Custom"}
//                         </span>
//                         {slot.slotId ? (
//                           <span className="badge bg-light text-dark">
//                             ID: {slot.slotId}
//                           </span>
//                         ) : null}
//                       </div>
//                       <button
//                         type="button"
//                         className="btn btn-outline-danger btn-sm"
//                         onClick={() => removeSlot(index)}
//                       >
//                         <FontAwesomeIcon icon={faTrash} />
//                       </button>
//                     </div>
//                     <div className="card-body">
//                       <div className="d-flex flex-nowrap overflow-auto gap-3">
//                         <div className="slot-field">
//                           <label className="form-label">
//                             <FontAwesomeIcon icon={faRupeeSign} className="me-1" />
//                             Price <span className="text-danger">*</span>
//                           </label>
//                           <input
//                             type="number"
//                             className="form-control"
//                             value={slot.libraryPrice}
//                             onChange={(event) =>
//                               handleSlotChange(
//                                 index,
//                                 "libraryPrice",
//                                 event.target.value
//                               )
//                             }
//                             // placeholder="100"
//                             min="1"
//                             required
//                           />
//                         </div>

//                         <div className="slot-field">
//                           <label className="form-label">
//                             <FontAwesomeIcon icon={faUsers} className="me-1" />
//                             Seats <span className="text-danger">*</span>
//                           </label>
//                           <input
//                             type="number"
//                             className="form-control"
//                             value={slot.numberOfSeats}
//                             onChange={(event) =>
//                               handleSlotChange(
//                                 index,
//                                 "numberOfSeats",
//                                 event.target.value
//                               )
//                             }
//                             // placeholder="10"
//                             min="1"
//                             required
//                           />
//                         </div>

//                         <div className="slot-field">
//                           <label className="form-label">Remaining</label>
//                           <input
//                             type="text"
//                             className="form-control"
//                             value={slot.remainingSeats || "0"}
//                             disabled
//                           />
//                         </div>

//                         <div className="slot-field-lg">
//                           <label className="form-label">
//                             <FontAwesomeIcon icon={faCalendarAlt} className="me-1" />
//                             Tenure <span className="text-danger">*</span>
//                           </label>
//                           <select
//                             className="form-select"
//                             value={slot.tenure}
//                             onChange={(event) =>
//                               handleSlotChange(index, "tenure", event.target.value)
//                             }
//                             required
//                           >
//                             <option value="">Select Tenure</option>
//                             {slot.tenure && !isTenureListed ? (
//                               <option value={slot.tenure}>{slot.tenure}</option>
//                             ) : null}
//                             {tenureList.map((tenure) => (
//                               <option key={tenure._id} value={tenure._id}>
//                                 {tenure.tenure}
//                               </option>
//                             ))}
//                           </select>
//                         </div>

//                         <div className="slot-field-xl">
//                           <label className="form-label">
//                             <FontAwesomeIcon icon={faClock} className="me-1" />
//                             From <span className="text-danger">*</span>
//                           </label>
//                           <div className="d-flex">
//                             <select
//                               className="form-select me-2"
//                               value={slot.fromTimeHours}
//                               onChange={(event) =>
//                                 handleSlotChange(
//                                   index,
//                                   "fromTimeHours",
//                                   event.target.value
//                                 )
//                               }
//                               required
//                             >
//                               <option value="">Select Time</option>
//                               {timeOptions.map((time) => (
//                                 <option key={time} value={time}>
//                                   {time}
//                                 </option>
//                               ))}
//                             </select>
//                             <select
//                               className="form-select"
//                               value={slot.fromTimestamp || "AM"}
//                               onChange={(event) =>
//                                 handleSlotChange(
//                                   index,
//                                   "fromTimestamp",
//                                   event.target.value
//                                 )
//                               }
//                               style={{ maxWidth: "70px" }}
//                             >
//                               <option value="AM">AM</option>
//                               <option value="PM">PM</option>
//                             </select>
//                           </div>
//                         </div>

//                         <div className="slot-field-xl">
//                           <label className="form-label">
//                             <FontAwesomeIcon icon={faClock} className="me-1" />
//                             To <span className="text-danger">*</span>
//                           </label>
//                           <div className="d-flex">
//                             <select
//                               className="form-select me-2"
//                               value={slot.toTimeHours}
//                               onChange={(event) =>
//                                 handleSlotChange(
//                                   index,
//                                   "toTimeHours",
//                                   event.target.value
//                                 )
//                               }
//                               required
//                             >
//                               <option value="">Select Time</option>
//                               {timeOptions.map((time) => (
//                                 <option key={time} value={time}>
//                                   {time}
//                                 </option>
//                               ))}
//                             </select>
//                             <select
//                               className="form-select"
//                               value={slot.toTimestamp || "AM"}
//                               onChange={(event) =>
//                                 handleSlotChange(
//                                   index,
//                                   "toTimestamp",
//                                   event.target.value
//                                 )
//                               }
//                               style={{ maxWidth: "70px" }}
//                             >
//                               <option value="AM">AM</option>
//                               <option value="PM">PM</option>
//                             </select>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           <div className="row">
//             <div className="col-12">
//               <div className="d-flex justify-content-end gap-2">
//                 <Link to="/library" className="btn btn-secondary">
//                   Cancel
//                 </Link>
//                 <button
//                   type="submit"
//                   className="btn btn-primary"
//                   disabled={saving || !hasUnsavedChanges}
//                 >
//                   {saving ? (
//                     <>
//                       <div
//                         className="spinner-border spinner-border-sm me-2"
//                         role="status"
//                       >
//                         <span className="visually-hidden">Loading...</span>
//                       </div>
//                       Updating Slots...
//                     </>
//                   ) : (
//                     <>
//                       <FontAwesomeIcon icon={faSave} className="me-2" />
//                       Save Slot Changes
//                     </>
//                   )}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </form>
//       </div>

//       <style>
//         {`
//           .slot-module-intro {
//             display: flex;
//             justify-content: space-between;
//             align-items: center;
//             gap: 12px;
//             padding: 14px 16px;
//             border: 1px solid #e9ecef;
//             background: linear-gradient(90deg, #f8fbff 0%, #ffffff 100%);
//             border-radius: 12px;
//           }

//           .slot-summary-card {
//             border: 1px solid #e9ecef;
//             border-radius: 12px;
//             padding: 12px;
//             background: #fff;
//             height: 100%;
//           }

//           .slot-combo-guide {
//             border: 1px solid #e9ecef;
//             border-radius: 12px;
//             background: #ffffff;
//             padding: 12px;
//           }

//           .slot-combo-guide table th,
//           .slot-combo-guide table td {
//             font-size: 13px;
//             vertical-align: middle;
//           }

//           .slot-combo-badge {
//             border: 1px solid #cfe2ff;
//             background: #eef6ff;
//             color: #1d4f91;
//             border-radius: 999px;
//             font-size: 11px;
//             font-weight: 600;
//             line-height: 1;
//             padding: 5px 10px;
//           }

//           .slot-combo-badge.custom {
//             border-color: #e9ecef;
//             background: #f8f9fa;
//             color: #6c757d;
//           }

//           .slot-summary-card p {
//             margin-bottom: 4px;
//             color: #6c757d;
//             font-size: 13px;
//           }

//           .slot-summary-card h5 {
//             margin-bottom: 0;
//           }

//           .slot-card {
//             border-radius: 12px;
//             border: 1px solid #e8edf4;
//             box-shadow: 0 3px 10px rgba(0, 0, 0, 0.03);
//           }

//           .slot-field {
//             min-width: 160px;
//           }

//           .slot-field-lg {
//             min-width: 190px;
//           }

//           .slot-field-xl {
//             min-width: 220px;
//           }

//           @media (max-width: 767px) {
//             .slot-module-intro {
//               flex-direction: column;
//               align-items: stretch;
//             }
//           }
//           .main-sec{
//             padding:20px 0;
//           }
//         `}
//       </style>
//     </section>
//   );
// }
"use client";

import { useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faPlus,
  faTrash,
  faSave,
  faClock,
  faRupeeSign,
  faUsers,
  faSpinner,
  faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";
import { baseUrl } from "../../config/baseUrl";

const createEmptySlot = () => ({
  libraryPrice: "",
  numberOfSeats: "",
  remainingSeats: "",
  tenure: "",
  fromTimeHours: "",
  fromTimestamp: "AM",
  toTimeHours: "",
  toTimestamp: "AM",
});

const MINUTES_IN_DAY = 24 * 60;

const parseTimeToMinutes = (timeHours, timestamp) => {
  if (!timeHours || !timestamp) {
    return null;
  }

  const [hourText, minuteText = "0"] = timeHours.split(":");
  const hour = Number(hourText);
  const minute = Number(minuteText);

  if (
    Number.isNaN(hour) ||
    Number.isNaN(minute) ||
    hour < 1 ||
    hour > 12 ||
    minute < 0 ||
    minute > 59
  ) {
    return null;
  }

  let normalizedHour = hour % 12;
  if (timestamp === "PM") {
    normalizedHour += 12;
  }

  return normalizedHour * 60 + minute;
};

const normalizeSlotRange = (slot) => {
  const start = parseTimeToMinutes(slot.fromTimeHours, slot.fromTimestamp || "AM");
  const endRaw = parseTimeToMinutes(slot.toTimeHours, slot.toTimestamp || "AM");

  if (start === null || endRaw === null) {
    return null;
  }

  return {
    start,
    end: endRaw <= start ? endRaw + MINUTES_IN_DAY : endRaw,
  };
};

const findContiguousSlotOrder = (slotRanges) => {
  for (let pivotIndex = 0; pivotIndex < slotRanges.length; pivotIndex++) {
    const pivotStart = slotRanges[pivotIndex].start;

    const orderedRanges = slotRanges
      .map((slotRange) => {
        let shiftedStart = slotRange.start;
        let shiftedEnd = slotRange.end;

        while (shiftedStart < pivotStart) {
          shiftedStart += MINUTES_IN_DAY;
          shiftedEnd += MINUTES_IN_DAY;
        }

        while (shiftedStart - pivotStart >= MINUTES_IN_DAY) {
          shiftedStart -= MINUTES_IN_DAY;
          shiftedEnd -= MINUTES_IN_DAY;
        }

        return {
          ...slotRange,
          start: shiftedStart,
          end: shiftedEnd,
        };
      })
      .sort((a, b) => a.start - b.start || a.end - b.end);

    let contiguous = true;

    for (let i = 1; i < orderedRanges.length; i++) {
      if (orderedRanges[i - 1].end !== orderedRanges[i].start) {
        contiguous = false;
        break;
      }
    }

    if (contiguous) {
      return orderedRanges;
    }
  }

  return null;
};

const convertMinutesToSlotTime = (totalMinutes) => {
  const normalizedMinutes =
    ((totalMinutes % MINUTES_IN_DAY) + MINUTES_IN_DAY) % MINUTES_IN_DAY;
  const hour24 = Math.floor(normalizedMinutes / 60);
  const minute = normalizedMinutes % 60;
  const timestamp = hour24 >= 12 ? "PM" : "AM";
  const hour12 = hour24 % 12 || 12;

  return {
    timeHours: `${hour12}:${minute.toString().padStart(2, "0")}`,
    timestamp,
  };
};

export default function LibrarySlots() {
  const navigate = useNavigate();
  const addedSlotIndexRef = useRef(null);

  const [fetchLoading, setFetchLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [tenureList, setTenureList] = useState([]);
  const [slots, setSlots] = useState([createEmptySlot()]);
  const [baselineSlots, setBaselineSlots] = useState("[]");
  const [selectedSlotIndexes, setSelectedSlotIndexes] = useState([]);

  const [libraryMeta, setLibraryMeta] = useState({
    libraryName: "",
    city: "",
    area: "",
  });
  const [libraryPayload, setLibraryPayload] = useState({
    libraryName: "",
    email: "",
    city: "",
    area: "",
    address: "",
    pinCode: "",
    contactPersonName: "",
    contactPersonNumber: "",
    aboutLibrary: "",
    paymentAcceptance: "Both",
    ownerName: "",
    ownerPhoneNumber: "",
    bankName: "",
    bankAccountNumber: "",
    bankIfscCode: "",
    emptyField1: "",
    emptyField2: "",
    adminCommission: {
      type: "",
      value: null,
    },
  });

  const timeOptions = useMemo(() => {
    const options = [];
    for (let i = 1; i <= 12; i++) {
      options.push(`${i}:00`);
      options.push(`${i}:30`);
    }
    return options;
  }, []);

  const hasUnsavedChanges = useMemo(
    () => JSON.stringify(slots) !== baselineSlots,
    [slots, baselineSlots]
  );

  const slotCount = slots.length;
  const totalSeats = slots.reduce(
    (sum, slot) => sum + (Number(slot.numberOfSeats) || 0),
    0
  );
  const totalRemainingSeats = slots.reduce(
    (sum, slot) => sum + (Number(slot.remainingSeats) || 0),
    0
  );
  const occupancyRate =
    totalSeats > 0
      ? Math.round(((totalSeats - totalRemainingSeats) / totalSeats) * 100)
      : 0;

  useEffect(() => {
    const initializePage = async () => {
      try {
        setFetchLoading(true);
        await Promise.all([fetchLibraryData(), fetchTenureData()]);
      } catch (error) {
        toast.error(error.message || "Failed to load library slots");
      } finally {
        setFetchLoading(false);
      }
    };

    initializePage();
  }, []);

  const fetchTenureData = async () => {
    const response = await fetch(`${baseUrl}/library-tenure?status=active`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    const data = await response.json();

    if (data.status && data.data) {
      setTenureList(data.data);
      return;
    }

    throw new Error(data.message || "Failed to fetch tenure data");
  };

  const fetchLibraryData = async () => {
    const response = await fetch(`${baseUrl}/owner/library/details`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    const data = await response.json();

    if (!(data.status && data.data)) {
      if (response.status === 401) {
        navigate("/login");
      }
      throw new Error(data.message || "Failed to fetch library data");
    }

    const library = data.data;

    setLibraryMeta({
      libraryName: library.libraryName || "My Library",
      city: library.city || "",
      area: library.area || "",
    });

    setLibraryPayload({
      libraryName: library.libraryName || "",
      email: library.email || "",
      city: library.city || "",
      area: library.area || "",
      address: library.address || "",
      pinCode: library.pinCode || "",
      contactPersonName: library.contactPersonName || "",
      contactPersonNumber: library.contactPersonNumber || "",
      aboutLibrary: library.aboutLibrary || "",
      paymentAcceptance: library.paymentAcceptance || "Both",
      ownerName: library.ownerName || "",
      ownerPhoneNumber: library.ownerPhoneNumber || "",
      bankName: library.bankName || "",
      bankAccountNumber: library.bankAccountNumber || "",
      bankIfscCode: library.bankIfscCode || "",
      emptyField1: library.emptyField1 || "",
      emptyField2: library.emptyField2 || "",
      adminCommission: {
        type: library?.adminCommission?.type || "",
        value:
          library?.adminCommission?.value === undefined
            ? null
            : library?.adminCommission?.value,
      },
    });

    const formattedSlots =
      library.slots && library.slots.length > 0
        ? library.slots.map((slot) => ({
          libraryPrice: slot.libraryPrice?.toString() || "",
          numberOfSeats: slot.numberOfSeats?.toString() || "",
          remainingSeats: slot.remainingSeats?.toString() || "",
          tenure: slot.tenure || "",
          fromTimeHours: slot.fromTimeHours || "",
          fromTimestamp: slot.fromTimestamp || "AM",
          toTimeHours: slot.toTimeHours || "",
          toTimestamp: slot.toTimestamp || "AM",
          slotId: slot.slotId,
          _id: slot._id,
        }))
        : [createEmptySlot()];

    setSlots(formattedSlots);
    setBaselineSlots(JSON.stringify(formattedSlots));
    setSelectedSlotIndexes([]);
  };

  const handleSlotChange = (index, field, value) => {
    setSlots((prev) =>
      prev.map((slot, slotIndex) =>
        slotIndex === index ? { ...slot, [field]: value } : slot
      )
    );
  };

  const addSlot = () => {
    setSlots((prev) => {
      const nextSlots = [...prev, createEmptySlot()];
      addedSlotIndexRef.current = nextSlots.length - 1;
      return nextSlots;
    });
  };

  const toggleSlotSelection = (index) => {
    setSelectedSlotIndexes((prev) =>
      prev.includes(index)
        ? prev.filter((selectedIndex) => selectedIndex !== index)
        : [...prev, index]
    );
  };

  const clearSlotSelection = () => {
    setSelectedSlotIndexes([]);
  };

  const combineSelectedSlots = () => {
    const uniqueIndexes = Array.from(
      new Set(
        selectedSlotIndexes.filter(
          (index) => index >= 0 && index < slots.length
        )
      )
    );

    if (uniqueIndexes.length < 2) {
      toast.info("Select at least 2 slots to combine");
      return;
    }

    const selectedSlots = uniqueIndexes.map((index) => ({
      index,
      slot: slots[index],
    }));

    const uniqueTenures = Array.from(
      new Set(selectedSlots.map(({ slot }) => slot.tenure).filter(Boolean))
    );

    if (uniqueTenures.length !== 1 || selectedSlots.some(({ slot }) => !slot.tenure)) {
      toast.error("Selected slots must have the same tenure");
      return;
    }

    const slotRanges = [];

    for (let i = 0; i < selectedSlots.length; i++) {
      const { index, slot } = selectedSlots[i];
      const normalizedRange = normalizeSlotRange(slot);

      if (!normalizedRange) {
        toast.error(`Select valid From/To time for Slot ${index + 1}`);
        return;
      }

      slotRanges.push({
        ...normalizedRange,
        index,
        slot,
      });
    }

    const orderedRanges = findContiguousSlotOrder(slotRanges);

    if (!orderedRanges) {
      toast.error("Selected slots must be continuous without gaps");
      return;
    }

    const combinedFromTime = convertMinutesToSlotTime(orderedRanges[0].start);
    const combinedToTime = convertMinutesToSlotTime(
      orderedRanges[orderedRanges.length - 1].end
    );
    const combinedTenure = uniqueTenures[0];

    const duplicateExists = slots.some((slot, index) => {
      if (uniqueIndexes.includes(index)) {
        return false;
      }

      return (
        slot.fromTimeHours === combinedFromTime.timeHours &&
        (slot.fromTimestamp || "AM") === combinedFromTime.timestamp &&
        slot.toTimeHours === combinedToTime.timeHours &&
        (slot.toTimestamp || "AM") === combinedToTime.timestamp &&
        slot.tenure === combinedTenure
      );
    });

    if (duplicateExists) {
      toast.info("A slot with this tenure and timing already exists");
      return;
    }

    const priceValues = orderedRanges.map((item) => Number(item.slot.libraryPrice));
    const seatValues = orderedRanges.map((item) => Number(item.slot.numberOfSeats));
    const remainingSeatValues = orderedRanges.map((item) =>
      Number(item.slot.remainingSeats)
    );

    const hasValidPrices = priceValues.every((value) => !Number.isNaN(value) && value > 0);
    const hasValidSeats = seatValues.every((value) => !Number.isNaN(value) && value > 0);
    const hasValidRemainingSeats = remainingSeatValues.every(
      (value) => !Number.isNaN(value) && value >= 0
    );

    const combinedPrice = hasValidPrices
      ? String(priceValues.reduce((sum, value) => sum + value, 0))
      : "";
    const combinedSeats = hasValidSeats ? String(Math.min(...seatValues)) : "";
    const combinedRemainingSeats = hasValidRemainingSeats
      ? String(Math.min(...remainingSeatValues))
      : combinedSeats;

    const combinedSlot = {
      ...createEmptySlot(),
      libraryPrice: combinedPrice,
      numberOfSeats: combinedSeats,
      remainingSeats: combinedRemainingSeats,
      tenure: combinedTenure,
      fromTimeHours: combinedFromTime.timeHours,
      fromTimestamp: combinedFromTime.timestamp,
      toTimeHours: combinedToTime.timeHours,
      toTimestamp: combinedToTime.timestamp,
    };

    setSlots((prev) => {
      const nextSlots = [...prev, combinedSlot];
      addedSlotIndexRef.current = nextSlots.length - 1;
      return nextSlots;
    });

    setSelectedSlotIndexes([]);
    toast.success("Combined slot created. Review and save changes.");
  };

  useEffect(() => {
    if (addedSlotIndexRef.current === null) {
      return;
    }

    const targetCard = document.getElementById(
      `library-slot-card-${addedSlotIndexRef.current}`
    );

    if (targetCard) {
      window.requestAnimationFrame(() => {
        targetCard.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }

    addedSlotIndexRef.current = null;
  }, [slots]);

  useEffect(() => {
    setSelectedSlotIndexes((prev) =>
      prev.filter((selectedIndex) => selectedIndex >= 0 && selectedIndex < slots.length)
    );
  }, [slots.length]);

  const removeSlot = (index) => {
    if (slots.length === 1) {
      toast.info("At least one slot is required");
      return;
    }

    setSelectedSlotIndexes((prev) =>
      prev
        .filter((selectedIndex) => selectedIndex !== index)
        .map((selectedIndex) =>
          selectedIndex > index ? selectedIndex - 1 : selectedIndex
        )
    );
    setSlots((prev) => prev.filter((_, slotIndex) => slotIndex !== index));
  };

  const validateSlots = () => {
    for (let i = 0; i < slots.length; i++) {
      const slot = slots[i];
      const slotLabel = slot.slotId || `Slot ${i + 1}`;

      if (!slot.libraryPrice || Number(slot.libraryPrice) <= 0) {
        toast.error(`Enter a valid price for ${slotLabel}`);
        return false;
      }

      if (!slot.numberOfSeats || Number(slot.numberOfSeats) <= 0) {
        toast.error(`Enter valid seats for ${slotLabel}`);
        return false;
      }

      if (!slot.tenure) {
        toast.error(`Select tenure for ${slotLabel}`);
        return false;
      }

      if (!slot.fromTimeHours || !slot.toTimeHours) {
        toast.error(`Select both From and To time for ${slotLabel}`);
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateSlots()) {
      return;
    }

    try {
      setSaving(true);

      const submitFormData = new FormData();

      Object.keys(libraryPayload).forEach((key) => {
        if (key === "adminCommission") {
          submitFormData.append(
            "adminCommission",
            JSON.stringify(libraryPayload[key])
          );
        } else {
          submitFormData.append(key, libraryPayload[key] || "");
        }
      });

      const sanitizedSlots = slots.map((slot) => ({
        libraryPrice: slot.libraryPrice,
        numberOfSeats: slot.numberOfSeats,
        remainingSeats: slot.remainingSeats,
        tenure: slot.tenure,
        fromTimeHours: slot.fromTimeHours,
        fromTimestamp: slot.fromTimestamp || "AM",
        toTimeHours: slot.toTimeHours,
        toTimestamp: slot.toTimestamp || "AM",
        slotId: slot.slotId,
        _id: slot._id,
      }));

      submitFormData.append("slots", JSON.stringify(sanitizedSlots));

      const response = await fetch(`${baseUrl}/owner/library/update`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: submitFormData,
      });

      const data = await response.json();

      if (data.status) {
        toast.success("Library slots updated successfully");
        await fetchLibraryData();
        return;
      }

      toast.error(data.message || "Failed to update library slots");
    } catch (error) {
      toast.error(error.message || "Failed to update library slots");
    } finally {
      setSaving(false);
    }
  };

  if (fetchLoading) {
    return (
      <section className="main-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="cards">
                <div className="text-center py-5">
                  <FontAwesomeIcon
                    icon={faSpinner}
                    spin
                    size="3x"
                    className="text-primary mb-3"
                  />
                  <h4>Loading Library Slots...</h4>
                  <p className="text-muted">
                    Please wait while we prepare your slot configuration.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="main-sec">
      <div className="container-fluid">
        <div className="row align-items-start">
          <div className="col-lg-8">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <FontAwesomeIcon icon={faBook} className="me-2" />
                Library Slots
              </h4>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/library">My Library</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Library Slots
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="col-lg-4 d-flex justify-content-lg-end">
            <Link to="/library" className="btn btn-outline-primary mt-2 mt-lg-0">
              Back to My Library
            </Link>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-12">
            <div className="slot-module-intro">
              <div>
                <h6 className="mb-1">{libraryMeta.libraryName}</h6>
                <p className="mb-0 text-muted">
                  {libraryMeta.area && libraryMeta.city
                    ? `${libraryMeta.area}, ${libraryMeta.city}`
                    : "Manage slot timings, capacity, and tenure from one place."}
                </p>
              </div>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={addSlot}
              >
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                Add Slot
              </button>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-12">
            <div className="slot-combine-actions">
              <div>
                <h6 className="mb-1">Combine Existing Slots</h6>
                <p className="mb-0 text-muted">
                  Select 2 or more continuous slots (for example Slot 1 + Slot 2)
                  and create a combined slot.
                </p>
              </div>
              <div className="d-flex flex-wrap gap-2">
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                  disabled={selectedSlotIndexes.length < 2}
                  onClick={combineSelectedSlots}
                >
                  Combine Selected ({selectedSlotIndexes.length})
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  disabled={selectedSlotIndexes.length === 0}
                  onClick={clearSlotSelection}
                >
                  Clear Selection
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="row mb-4">
          <div className="col-md-3 col-6 mb-3">
            <div className="slot-summary-card">
              <p>Total Slots</p>
              <h5>{slotCount}</h5>
            </div>
          </div>
          <div className="col-md-3 col-6 mb-3">
            <div className="slot-summary-card">
              <p>Total Seats</p>
              <h5>{totalSeats}</h5>
            </div>
          </div>
          <div className="col-md-3 col-6 mb-3">
            <div className="slot-summary-card">
              <p>Remaining Seats</p>
              <h5>{totalRemainingSeats}</h5>
            </div>
          </div>
          <div className="col-md-3 col-6 mb-3">
            <div className="slot-summary-card">
              <p>Occupancy</p>
              <h5>{occupancyRate}%</h5>
            </div>
          </div>
        </div> */}

        <form onSubmit={handleSubmit}>
          <div className="row mb-3">
            {slots.map((slot, index) => {
              const slotTitle = slot.slotId || `Slot ${index + 1}`;
              const isTenureListed = tenureList.some(
                (tenure) => tenure._id === slot.tenure
              );
              const isSlotSelected = selectedSlotIndexes.includes(index);

              return (
                <div
                  id={`library-slot-card-${index}`}
                  key={`${slot._id || "new"}-${index}`}
                  className="col-12 mb-3"
                >
                  <div
                    className={`card slot-card ${isSlotSelected ? "slot-card-selected" : ""}`}
                  >
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center gap-2">
                        <label className="slot-select-toggle mb-0">
                          <input
                            type="checkbox"
                            checked={isSlotSelected}
                            onChange={() => toggleSlotSelection(index)}
                          />
                          <span>Select</span>
                        </label>
                        <h6 className="mb-0">{slotTitle}</h6>
                        {slot.slotId ? (
                          <span className="badge bg-light text-dark">
                            ID: {slot.slotId}
                          </span>
                        ) : null}
                      </div>
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => removeSlot(index)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </div>
                    <div className="card-body">
                      <div className="d-flex flex-nowrap overflow-auto gap-3">
                        <div className="slot-field">
                          <label className="form-label">
                            <FontAwesomeIcon icon={faRupeeSign} className="me-1" />
                            Price <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            value={slot.libraryPrice}
                            onChange={(event) =>
                              handleSlotChange(
                                index,
                                "libraryPrice",
                                event.target.value
                              )
                            }
                            // placeholder="100"
                            min="1"
                            required
                          />
                        </div>

                        <div className="slot-field">
                          <label className="form-label">
                            <FontAwesomeIcon icon={faUsers} className="me-1" />
                            Seats <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            value={slot.numberOfSeats}
                            onChange={(event) =>
                              handleSlotChange(
                                index,
                                "numberOfSeats",
                                event.target.value
                              )
                            }
                            // placeholder="10"
                            min="1"
                            required
                          />
                        </div>

                        <div className="slot-field">
                          <label className="form-label">Remaining</label>
                          <input
                            type="text"
                            className="form-control"
                            value={slot.remainingSeats || "0"}
                            disabled
                          />
                        </div>

                        <div className="slot-field-lg">
                          <label className="form-label">
                            <FontAwesomeIcon icon={faCalendarAlt} className="me-1" />
                            Tenure <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            value={slot.tenure}
                            onChange={(event) =>
                              handleSlotChange(index, "tenure", event.target.value)
                            }
                            required
                          >
                            <option value="">Select Tenure</option>
                            {slot.tenure && !isTenureListed ? (
                              <option value={slot.tenure}>{slot.tenure}</option>
                            ) : null}
                            {tenureList.map((tenure) => (
                              <option key={tenure._id} value={tenure._id}>
                                {tenure.tenure}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="slot-field-xl">
                          <label className="form-label">
                            <FontAwesomeIcon icon={faClock} className="me-1" />
                            From <span className="text-danger">*</span>
                          </label>
                          <div className="d-flex">
                            <select
                              className="form-select me-2"
                              value={slot.fromTimeHours}
                              onChange={(event) =>
                                handleSlotChange(
                                  index,
                                  "fromTimeHours",
                                  event.target.value
                                )
                              }
                              required
                            >
                              <option value="">Select Time</option>
                              {timeOptions.map((time) => (
                                <option key={time} value={time}>
                                  {time}
                                </option>
                              ))}
                            </select>
                            <select
                              className="form-select"
                              value={slot.fromTimestamp || "AM"}
                              onChange={(event) =>
                                handleSlotChange(
                                  index,
                                  "fromTimestamp",
                                  event.target.value
                                )
                              }
                              style={{ maxWidth: "70px" }}
                            >
                              <option value="AM">AM</option>
                              <option value="PM">PM</option>
                            </select>
                          </div>
                        </div>

                        <div className="slot-field-xl">
                          <label className="form-label">
                            <FontAwesomeIcon icon={faClock} className="me-1" />
                            To <span className="text-danger">*</span>
                          </label>
                          <div className="d-flex">
                            <select
                              className="form-select me-2"
                              value={slot.toTimeHours}
                              onChange={(event) =>
                                handleSlotChange(
                                  index,
                                  "toTimeHours",
                                  event.target.value
                                )
                              }
                              required
                            >
                              <option value="">Select Time</option>
                              {timeOptions.map((time) => (
                                <option key={time} value={time}>
                                  {time}
                                </option>
                              ))}
                            </select>
                            <select
                              className="form-select"
                              value={slot.toTimestamp || "AM"}
                              onChange={(event) =>
                                handleSlotChange(
                                  index,
                                  "toTimestamp",
                                  event.target.value
                                )
                              }
                              style={{ maxWidth: "70px" }}
                            >
                              <option value="AM">AM</option>
                              <option value="PM">PM</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="row">
            <div className="col-12">
              <div className="d-flex justify-content-end gap-2">
                <Link to="/library" className="btn btn-secondary">
                  Cancel
                </Link>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={saving || !hasUnsavedChanges}
                >
                  {saving ? (
                    <>
                      <div
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      Updating Slots...
                    </>
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faSave} className="me-2" />
                      Save Slot Changes
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <style>
        {`
          .slot-module-intro {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;
            padding: 14px 16px;
            border: 1px solid #e9ecef;
            background: linear-gradient(90deg, #f8fbff 0%, #ffffff 100%);
            border-radius: 12px;
          }

          .slot-summary-card {
            border: 1px solid #e9ecef;
            border-radius: 12px;
            padding: 12px;
            background: #fff;
            height: 100%;
          }

          .slot-summary-card p {
            margin-bottom: 4px;
            color: #6c757d;
            font-size: 13px;
          }

          .slot-summary-card h5 {
            margin-bottom: 0;
          }

          .slot-combine-actions {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;
            padding: 14px 16px;
            border: 1px solid #e6edf8;
            border-radius: 12px;
            background: #f9fbff;
          }

          .slot-card {
            border-radius: 12px;
            border: 1px solid #e8edf4;
            box-shadow: 0 3px 10px rgba(0, 0, 0, 0.03);
          }

          .slot-card-selected {
            border-color: #86b7fe;
            box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.1);
          }

          .slot-select-toggle {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            font-size: 12px;
            color: #4a5a70;
            border: 1px solid #dbe6f8;
            border-radius: 999px;
            padding: 2px 8px;
            background: #fff;
            user-select: none;
          }

          .slot-select-toggle input {
            margin: 0;
          }

          .slot-field {
            min-width: 160px;
          }

          .slot-field-lg {
            min-width: 190px;
          }

          .slot-field-xl {
            min-width: 220px;
          }

          @media (max-width: 767px) {
            .slot-module-intro {
              flex-direction: column;
              align-items: stretch;
            }

            .slot-combine-actions {
              flex-direction: column;
              align-items: stretch;
            }
          }
          .main-sec{
            padding:20px 0;
          }
        `}
      </style>
    </section>
  );
}
